import { API, graphqlOperation } from "aws-amplify";
import {
  updateAccount,
  updateUpdateDiscountArraybyShopId,
  updateOrder,
} from "../graphql/myMutations";
import {
  getCurrentDiscountArraybyShopId,
  getOrder,
} from "../graphql/myQueries";
import usePushNotifications from "./usePushNotifications";
const useToCancelOrders = () => {
  const { sendOneSignalNotifications } = usePushNotifications();

  const getTheOrder = async (id, order, deliveryId) => {
    API.graphql(graphqlOperation(getOrder, { id: id }))
      .then((result) => {
        if (!!result) {
          let response = JSON.parse(result.data.getOrder.history);
          let last = response[response.length - 1];
          if (last.change) {
            if (last.change === "ORDER ACCEPTED") {
              //console.log("No cancelar--------------->");
            } else if (last.change === "ASSIGMENT IN SERVICE DESKTOP") {
              //console.log("Cancelar la orden---------------->A ");
              cancelAssignmentToDelivery(order, deliveryId);
            }
          } else {
           // console.log("Cancelar la orden---------------->B ");
            cancelAssignmentToDelivery(order, deliveryId);
          }

          //cancelAssignmentToDelivery(order, deliveryId); //DESCOMENTAR
        }
      })
      .catch((error) => {
        console.log("Error [onFinishDecline] ", error);
      });
  };

  /**
   * Function to remove an order assigned to a delivery
   */
  const cancelAssignmentToDelivery = (order, deliveryId) => {
    //? disabled buttons
    //setLoading(true);

    //? get array suggesting_dealers
    let arrayBadDealers = !!order?.suggesting_dealers
      ? order?.suggesting_dealers
      : [];
    //? insert dealer
    arrayBadDealers.push(order?.delivery_man_id?.id);

    //? save the change in history
    let newHistory = JSON.parse(order?.history);
    let newChange = {
      hour: new Date(),
      level: order?.level,
      status: "DENIED",
      user: order?.delivery_man_id?.id,
    };
    newHistory.push(newChange);
    newHistory = JSON.stringify(newHistory);

    //? input to update order (return to assignment)
    let inputOrder = {
      id: order?.id,
      level: "EN PROCESO",
      status: "LISTO",
      suggesting_dealers: arrayBadDealers,
      history: newHistory,
      orderDelivery_man_idId: " ",
    };
    //? update the order
    API.graphql(graphqlOperation(updateOrder, { input: inputOrder }))
      .then((result) => {
        if (!!result) {
          //console.log("updated correctly ", result);
          freeDelivery(deliveryId);
        }
      })
      .catch((error) => {
        console.log("Error [onFinishDecline] ", error);
      });
  };

  /**
   * Function to set free delivery after to cancell an order assigned
   */
  const freeDelivery = (delivery_id) => {
    let inputDelivery = {
      id: delivery_id,
      delivery_inprocess: false,
      role: "deliveryman",
    };

    API.graphql(graphqlOperation(updateAccount, { input: inputDelivery }))
      .then((result) => {
        if (!!result) {
          //console.log("updated correctly dealer ", result);
        }
      })
      .catch((error) => {
        console.log("Error [freeDelivery] ", error);
      });
  };

  const cancelOrderbyTime = async (order) => {
    //setVisible(false);
    //alert("Cancelar orden");

    let newDate = new Date();
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());

    var initialObj = {
      rol: "SYSTEM",
      subject: "THE SHOP EXCEEDED ANSWER TIME",
      details: "ANY",
      hour: newDate,
      protocol: 1,
    };
    try {
      var info = {
        id: order.id,
        status: "CANCELADA",
        canceled: JSON.stringify(initialObj),
        level: "FINALIZADO",
      };
      if (calculateTimebyUpdatedDate(order.updatedAt, order) === "00:00:00") {
        const result = await API.graphql(
          graphqlOperation(updateOrder, { input: info })
        );

        if (result) {
          updateCashBack(order);
          checkDiscount(order);
        }
      }/*  else {
        console.log(
          "Intento cancelar pero no habia excedido el tiempo--------------->"
        );
      } */

      /*Alert.alert(
            "¡Lo sentimos, tu orden ha sido cancelada!",
            "La tienda ha demorado mucho tiempo en atender tu orden"
          );*/
    } catch (error) {
      console.log(
        "Error al cancelar la orden por exceder el límite de tiempo de respuesta",
        error
      );
    }

    //Alert.alert("Por cancelar orden", "Cancelar la orden-------------->");
  };

  const calculateTimebyUpdatedDate = (start, order) => {
    let deadline = new Date(start);
    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 600);
    //console.log("Tiempo límite: " + deadline + " del item: " + orderID);
    const total = Date.parse(new Date(deadline)) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor(((total / 1000) * 60 * 60) % 24);

    var toReturn =
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds);

    var allTime = minutes * 60 + seconds;
    if (allTime <= 0) {
      return "00:00:00";
    } else if (allTime <= 600) {
      checkDiscount(order);
      return toReturn;
    } else {
      return "00:00:00";
    }
  };

  const updateCashBack = async (order) => {
    //console.log("Por cancelar la orden------> y acutalizar NC ", order);
    var total = order.total;
    var cashBack = order.nc;
    /* console.log("NC: ", order.customer_id.nikucoins);
    console.log("Quitar: ", cashBack);
    console.log("Porcentaje cedido: ", order.shop_id.percentage_traded.value);
    console.log("Total de la compra: ", total); */
    var newNC =
      order.customer_id.nikucoins - cashBack < 0
        ? 0
        : order.customer_id.nikucoins - cashBack;
    //console.log("🚀 NC con el descuento de la orden", newNC);
    try {
      var updateNC = {
        id: order.customer_id.id,
        nikucoins: newNC,
      };

      const result = await API.graphql(
        graphqlOperation(updateAccount, { input: updateNC })
      );
      sendCancelNotificacionToSeller(order);
      sendCancelNotification(order);
      //console.log("🚀 ~  result", result);
    } catch (error) {
      console.log("Error al actualizar las NC del cliente", error);
    }
  };

  const sendCancelNotification = (order) => {
    sendOneSignalNotifications({
      content: "¡Tu orden ha sido cancelada! La tienda no ha contestado",
      title: "¡Lo sentimos!",
      ids: [order.customer_id.id],
      channel: "new-message",
      role: "customers",
    });
  };

  const sendCancelNotificacionToSeller = (order) => {
    sendOneSignalNotifications({
      content:
        "El cliente ha esperado demasiado por una respuesta, la orden ha sido cancelada",
      title: "¡" + order.shop_id.shop_name + " tienes una orden cancelada!",
      ids: [order.shop_id.seller_id.id],
      channel: "new-message",
      role: "seller",
    });
  };

  const checkDiscount = async (order) => {
    /*  console.log("Por validar los cambios del descuento"); */
    try {
      const result = await API.graphql(
        graphqlOperation(getCurrentDiscountArraybyShopId, {
          id: order.shop_id.id,
        })
      );
      var currentArrayBD = JSON.parse(result.data.getShop.discountsArray);
      /* console.log("El arreglo ANTES---->", JSON.stringify(currentArrayBD)); */
      var found = false; //si encontré el valor en el arreglo
      var added = false; //para saber si ya lo agregué
      for (let x = 0; x < currentArrayBD.length; x++) {
        if (!added) {
          var elementArray = currentArrayBD[x];
          //console.log("Arreglo que se recorre: ", elementArray);
          found = elementArray.find((element) => element === order.percentage);

          if (found) {
            //console.log("Lo encontré en el arreglo: " + x);
            /////
            var quantity = 0;
            var currentB = JSON.parse(
              order.shop_id.percentage_traded.array_ofDiscount
            );
            var quantityA = 0; //cantidad de elementos iguales al porcentage otorgado y que se encuentran en el arreglo actual de la tienda
            //Buscamos en el arreglo inicial (reset) cuantos elementos del arreglo deben de estar
            //de tal forma que si deben existir 2 veces un 85, nos permita saber si debemos o no agregar un valor
            currentB.forEach((element) => {
              // console.log(":--->" + element + " vs " + percentageO);
              if (element === order.percentage) {
                /*                 console.log(
                  "Encontrado------------->" +
                    element +
                    "-----" +
                    order.percentage
                ); */
                quantity++;
              }
            });

            if (quantity == 1) {
              /*  console.log("Cierto, no debe de agregarse", quantity); */
            } else {
              for (let z = 0; z < currentArrayBD.length; z++) {
                var currentA = currentArrayBD[z];
                quantityA = 0;
                currentA.forEach((element) => {
                  if (element === order.percentage) {
                    //console.log("Encontrado", element);
                    quantityA++;
                  }
                });
                if (quantityA < quantity) {
                  //Si la cantidad de elementos que hay en el arreglo actual de la tienda
                  //es menor a la que debe de existir por definición (reset) entonces agregaremos el valor
                  //sin afectar la cantidad de elementos del arreglo inicial
                  /*  console.log(
                    "Se agregará el elemento " +
                      order.percentage +
                      " al arreglo: " +
                      currentA
                  ); */
                  currentA.push(order.percentage);
                  added = true;
                } else {
                  /*  console.log(
                    z +
                      "---No debe agregarse nada---->En el arreglo inicial debe existir: " +
                      quantity +
                      " En el arreglo actual hay: " +
                      quantityA +
                      " valores de: " +
                      order.percentage +
                      "\n------>" +
                      currentA
                  ); */
                }
              }
            }
          } else {
            /* console.log("No lo encontré en el arreglo: " + x); */
            elementArray.push(order.percentage);
            /*console.log(
              "🚀 ~ file: newTimer.js ~ line 220 ~ checkDiscount ~ order",
              order.percentage
            );*/
            added = true;
          }
        } else {
          console.log("El elemento ya ha sido agregado a algun arreglo");
        }
      }
      if (added) {
        /*  console.log("Por actualizar el arreglo en la BD", currentArrayBD);
        console.log("🚀 ~ ~ currentArrayBD", JSON.stringify(currentArrayBD)); */
        updateArrayDiscountDB(currentArrayBD, order);
      } else {
        console.log("No hay modificaciones");
      }
    } catch (error) {
      console.log("Error al obtener los descuentos de la tienda", error);
      //Alert.alert("¡Oops!", "Algo salió mal con el descuento");
    }
  };

  const updateArrayDiscountDB = async (array, order) => {
    //console.log("El arreglo normal----------------------->", array);
    try {
      //console.log("Item nuevo", item);
      var jsonArray = JSON.stringify(array);
      //console.log("El arreglo en JSON", jsonArray);
      const result = await API.graphql(
        graphqlOperation(updateUpdateDiscountArraybyShopId, {
          input: {
            id: order.shop_id.id,
            discountsArray: jsonArray,
          },
        })
      );
      ///
    } catch (error) {
      console.log(
        "Error al actualizar el arreglo de descuentos en la base de datos",
        error
      );
    }
  };

  return {
    updateCashBack,
    cancelOrderbyTime,
    sendCancelNotificacionToSeller,
    cancelAssignmentToDelivery,
    getTheOrder,
  };
};

export default useToCancelOrders;
